module.exports = __webpack_public_path__ + "static/media/icons_fecha.22cbe7f1.png";